var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m.189 12.175 4.936-5.062L.063 2.176 1.037.164l7.088 6.91-6.911 7.089z"
  })));
};
export { SvgRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDkgMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjE4ODYwMiAxMi4xNzUzTDUuMTI1MTggNy4xMTI2NUwwLjA2MjU1MDkgMi4xNzYwN0wxLjAzNzI2IDAuMTYzNjI4TDguMTI0OTQgNy4wNzQ4NEwxLjIxMzczIDE0LjE2MjVMMC4xODg2MDIgMTIuMTc1M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";